<template>
    <div class="create-account">
        <div class="top-header">
            <div>
                <div>
                    <a href="http://fexspace.com"><img src="@/assets/logo-small.png" /></a>
                </div>
                <div class="flex">
                    <a class="mobile">
                        <span @click="show_dropdown">
                            <svg style="width:44px;height:44px" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
                            </svg>
                        </span>
                        <ul v-if="dropdown">
                            <li>
                                <a href="http://fexspace.com/pricing">Pricing</a>
                            </li>
                            <li>
                                <a href="http://fexspace.com/faq">FAQ</a>
                            </li>
                            <li>
                                <a href="http://fexspace.com/request-quote">Contact Sales</a>
                            </li>
                            <li class="last">
                                <router-link to="/login">Sign In</router-link>
                            </li>
                        </ul>
                    </a>
                    <ul class="desk">
                        <li>
                            <a href="http://fexspace.com/pricing">Pricing</a>
                        </li>
                        <li>
                            <a href="http://fexspace.com/faq">FAQ</a>
                        </li>
                        <li>
                            <a href="http://fexspace.com/request-quote">Contact Sales</a>
                        </li>
                        <li>
                            <router-link to="/login">Sign In</router-link>
                        </li>
                        <li class="logout" v-if="name != ''" @click="logout" style="color:#000"><i class="fa fa-sign-out-alt"></i> Logout</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="create-form">
            <div class="form" v-if="stage == 1 && user_id == ''">
                <h3>Create Acount</h3>
                <form @keypress="send">
                    <div class="input">
                        <div>
                            <label for="firstname">
                                First Name
                            </label>
                            <input type="text" placeholder="First Name" v-model="firstname" @focus="input_focus('firstname')" @blur="input_blur('firstname')" />
                            <span class="err" v-if="error.firstname">*Required</span>
                        </div>
                        <div>
                            <label for="lastname">
                                Last Name
                            </label>
                            <input type="text" placeholder="Last Name" v-model="lastname" @focus="input_focus('lastname')" @blur="input_blur('lastname')" />
                            <span class="err" v-if="error.lastname">*Required</span>
                        </div>
                    </div>
                    <div class="input">

                    </div>
                    <div class="input">
                        <div>
                            <label for="email">
                                Email Address
                            </label>
                            <template v-if="checkEmail(email) && code != ''">
                                <input type="text" placeholder="Email Address" disabled v-model="email" @focus="input_focus('email')" @blur="input_blur('email')" />
                            </template>
                            <template v-if="(!checkEmail(email) || checkEmail(email))  && code == ''">
                                <input type="text" placeholder="Email Address" v-model="email" @focus="input_focus('email')" @blur="input_blur('email')" />
                            </template>
                            <span class="err" v-if="error.format">*Please enter a valid email</span>
                            <span class="err" v-if="error.exist">*Email already used</span>
                            <span class="err" v-if="error.email">*Required</span>
                        </div>
                        <div>
                            <label for="password">
                                Password
                            </label>
                            <div class="pos">
                                <input :type="[!reveal?'password':'text']" placeholder="Password" v-model="password" @focus="input_focus('password')" @blur="input_blur('password')" />
                                <span class="reveal" @click="reveal_password">
                                    <i class="fa" :class="{'fa-eye': reveal, 'fa-eye-slash': !reveal}"></i>
                                </span>
                            </div>
                            <span class="err" v-if="error.password_length">*Password length must not be less<br/> than 8 characters</span>
                            <span class="err" v-if="error.password">*Required</span>
                        </div>
                    </div>
                    <div class="input">
                        <div class="email">
                            <label for="email">
                                AppSumo Code
                            </label>
                            <input type="text" placeholder="AppSumo Code" v-model="gencode" />
                            <span class="err" v-if="error.gencode">*Please enter your AppSumo code</span>
                            <span class="err" v-if="error.message">{{ error.message }}</span>
                        </div>
                    </div>
                    <div class="submit">
                        <button type="button" @click="submit">Continue</button>
                        <p>Already have an account? <router-link to="/login">Sign In</router-link></p>
                    </div>
                    <div class="text">
                        <p>By submitting this form, you confirm that you agree to the storing and processing of your personal data by Fexspace as described in our <a :href="[ng? 'https://fexspace.com/ng/terms-condition' : 'https://fexspace.com/terms-condition']">Terms of Service</a> and <a :href="[ng? 'http://fexspace.com/ng/privacy-policy' : 'http://fexspace.com/privacy-policy']">Privacy Policy</a></p>
                    </div>
                </form>
            </div>
        </div>
        <loader ref="loader"></loader>
        <loading ref="loading"></loading>
        <logout ref="logout"></logout>
    </div>
</template>
<style scoped>
.pos {
    position: relative;
}
.pos .reveal {
    position: absolute;
    top: 12px;
    right: 12px;
}
.create-form {
  background: #fbfbfb;
  height: calc(100vh - 64px);
  overflow: auto;
}
.create-form .form {
    width: 30%;
    margin-top: 3em !important;
}
.create-form .form .input {
    justify-content: initial !important;
}
.create-form .form .input div {
    flex-grow: 1;
}
.create-form .form .input div input {
    width: 100%;
}
.top-plan p {
    padding: 0 1em;
}
.top-plan p strong {
    color: #fff;
}
.top-header > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1em 1em;
    font-family: 'heebo-medium';
}
.create-form {
    font-family: 'heebo-light';
}
.create-form .text {
    font-family: 'heebo-medium';
}
.create-form label {
    font-family: 'heebo-medium';
}
.create-form div.submit p {
    font-family: 'heebo-medium';
}
.top-header > div div:first-child {
    flex-grow: 1;
    text-align: left;
}

.top-header .flex {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    text-align: right;
}

.top-header .flex ul {
    display: flex;
    margin-bottom: 0;
}

.top-header .flex ul li a {
    color: #fff;
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: 500;
}

.top-header .flex ul li a:hover {
    text-decoration: none;
}

.top-header .flex ul li:last-child a {
    background: #0d538d;
    border-radius: 3px;
    padding-top: .5em;
    padding-bottom: .5em;
    margin-left: 1.4em;
}

.pricing .choose-plan {
        padding: 0;
    }
    .choose-plan .top-plan {
        background-color: #0a5ea3;
        padding: 2em 0 8em;
    }
    .choose-plan .top-plan h3 {
        color: #fff !important;
        font-size: 40px;
        margin-top: 1em;
        text-align: center;
    }
    .list {
        display: grid;
        grid-template-columns: 20% repeat(4,1fr);
        -ms-grid-columns: 1fr;
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        margin-top: -140px;
        text-align: center;
    }
    .list:last-child {
        margin-bottom: 3em;
        margin-top: 0;
    }
    .list div {
        background: #fff;
        border: 1px solid #e3eee3;
        padding: .8em .9em;
    }
    .list:last-child div {
        background: #fff;
        border: 1px solid #e3eee3;
        padding: 0;
    }
    .list:last-child div ul {
        margin-bottom: 0;
    }
    .list:last-child div ul li {
        padding: .8em .6em;
        font-size: 14px;
    }
    .list:last-child div ul li:nth-child(even) {
        background-color: #f9f9f9;
        border-bottom: 1px solid #f1f1f1;
        border-top: 1px solid #f1f1f1;
    }
    .list div h3 {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 24px;
    }
    .list div p {
        font-size: 14px;
    }
    .list div .price {
        font-weight: bold;
        font-size: 15px;
    }
    .list div p span {
        cursor: pointer;
    }
    .list div p span.paid a {
        display: inline-block;
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#0984e2+0,1e5799+100 */
        background: #0984e2; /* Old browsers */
        background: -moz-linear-gradient(top,  #0984e2 0%, #1e5799 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  #0984e2 0%,#1e5799 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  #0984e2 0%,#1e5799 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0984e2', endColorstr='#1e5799',GradientType=0 ); /* IE6-9 */
        border-radius: 3px;
        padding: .6em .8em;
        color: #fff;
        border: 1px solid #1e5799;
        width: 120px;
    }
    .list div p span.paid a:hover {
        text-decoration: none;
    }
    .list div p span.trial a:hover {
        text-decoration: none;
    }
    .list div p span.trial a {
        display: inline-block;
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#cc0600+0,a01503+100 */
        background: #cc0600; /* Old browsers */
        background: -moz-linear-gradient(top,  #cc0600 0%, #a01503 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  #cc0600 0%,#a01503 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  #cc0600 0%,#a01503 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cc0600', endColorstr='#a01503',GradientType=0 ); /* IE6-9 */
        border-radius: 3px;
        padding: .6em .8em;
        color: #fff;
        border: 1px solid #940601;
        margin-top: .6em;
        width: 120px;
    }
    .extra {
        padding: 1.55em .8em !important;
    }
    .sticky {
        position: fixed;
        width: 100%;
        top: 0;
    }
    .list-header {
        margin: 0 auto;
    }
    .list-header div {
        display: flex;
        flex-direction: column;
        padding: 1em .9em !important;
        border-bottom: none !important;
    }
    .list-header div h3 {
        margin: 0;
    }
    .create-form {
        align-items: initial !important;
    }
    .create-form .form {
        margin: 0;
    }
    .text {
        font-size: 12px;
    }
 </style>

<script>
import { mapMutations } from 'vuex'
import AuthenticationService from '@/services/AuthenticationService'
import loader from '@/components/Loader'
import loading from '@/components/Loading'
import cookies from '@/services/cookies'
import axios from 'axios'
import logout from '@/components/Logout'

export default {
  components: {
    logout,
    loader,
    loading
  },
  data () {
    return {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      confirm: '',
      reveal: false,
      error: {
        firstname: false,
        lastname: false,
        email: false,
        valid_email: false,
        password: false,
        confirm: false,
        password_length: false,
        mismatch: false,
        exist: false,
        format: false,
        message: ''
      },
      dropdown: false,
      post: true,
      country: '',
      prices: '',
      sticky: false,
      stage: localStorage.getItem('stage') ? localStorage.getItem('stage') : 1,
      user_id: localStorage.getItem('user_id') ? localStorage.getItem('user_id') : '',
      name: localStorage.getItem('name') ? localStorage.getItem('name') : '',
      country: '',
      code: '',
      gencode: '',
      ng: false,
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    ...mapMutations([
      'SET_USER_TOKEN'
    ]),
    checkEmail (email) {
      return this.str.test(this.email)
    },
    show_dropdown () {
      this.dropdown = !this.dropdown
    },
    reveal_password () {
      this.reveal = !this.reveal
    },
    logout () {
      this.$refs.logout.logout()
    },
    input_focus (txt) {
      this.error[txt] = false

      if (txt == 'email') {
        this.error.exist = false
      }
    },
    input_blur (txt) {
      if (this[txt] == '') {
        this.error[txt] = true
      } else {
        this.error[txt] = false
      }
    },
    free_plan () {
      this.$refs.loading.load()
      let that = this

      let data = {
        user_id: this.user_id,
        plan: 1,
        stage: 2
      }
      AuthenticationService.free_plan(data).then(res => {
        if (res.data.error == false) {
          that.$refs.loading.close()
          that.$store.commit('SET_USER_TOKEN', cookies.getCookie('token'))
          // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
          that.$router.push('setup-account')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    buy (plan) {
      localStorage.setItem('plan', plan)
      this.$router.push('/buy/payment')
    },
    trial (plan) {
      this.$refs.loading.load()
      let that = this

      let data = {
        user_id: this.user_id,
        plan: plan,
        stage: 2
      }
      AuthenticationService.trial(data).then(res => {
        if (res.data.error === false) {
          that.$refs.loading.close()
          that.$store.commit('SET_USER_TOKEN', cookies.getCookie('token'))
          // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
          that.$router.push('setup-account')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleScroll () {
      if (window.scrollY >= 555) {
        this.sticky = true
      } else {
        this.sticky = false
      }
    },
    send (evt) {
      if (evt.keyCode === 13) {
        this.post = true
        this.error.exist = false

        if (this.firstname === '') {
          this.error.firstname = true
          this.post = false
        } else {
          this.error.lastname = false
        }

        if (this.lastname === '') {
          this.error.lastname = true
          this.post = false
        } else {
          this.error.lastname = false
        }

        if (this.gencode === '') {
          this.error.gencode = true
          this.post = false
        } else {
          this.error.gencode = false
        }

        if (this.email == '') {
          this.error.email = true
          this.post = true
        } else {
          this.error.email = false

          if (this.str.test(this.email) === false) {
            this.error.format = true
            this.post = false
          } else {
            this.error.format = false
          }
        }

        if (this.password === '') {
          this.error.password = true
          this.post = false
        } else {
          this.error.password_length = false
          if (this.password.length < 8) {
            this.error.password_length = true
            this.post = false
          } else {
            this.error.password = false
          }
        }

        if (this.post) {
          this.$refs.loader.load()

          let data = {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            password: this.password,
            stage: sessionStorage.getItem('um') == 'trial' ? 6 : 1,
            plan: this.$route.query.pn,
            type: this.$route.query.type,
            code: this.code,
            gencode: this.gencode,
            ref: this.ref,
            country: this.country
          }

          let that = this

          AuthenticationService.useappsumocode(data).then(res => {
            if (res.data.error === true) {
              if (res.data.message === undefined || res.data.message === '') {
                that.$refs.loader.close()
                that.error.exist = true
              } else {
                that.$refs.loader.close()
                that.error.message = res.data.message
              }
            }

            if (res.data.error === false) {
              if (sessionStorage.getItem('um') == 'trial') {
                if (process.env.NODE_ENV == 'development') {
                  if (res.data.source !== '' && res.data.source !== undefined) {
                    cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                    sessionStorage.removeItem('um')
                    window.location = res.data.url
                  } else {
                    cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                    sessionStorage.removeItem('um')
                    window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                  }
                } else {
                  if (res.data.source !== '' && res.data.source !== undefined) {
                    cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                    sessionStorage.removeItem('um')
                    window.location = 'http:fexspace.com/pricing-free-trial'
                  } else {
                    cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                    sessionStorage.removeItem('um')
                    window.location = res.data.url
                  }
                }
              } else {
                if (res.data.url !== '') {
                  if (Number(res.data.type) === 1) {
                  // Redirect user to choose a plan
                    cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                    cookies.setCookie('email', that.email, 6 * 60 * 60 * 1000)
                    that.$router.push('/')
                  } else {
                  // Redirect user to choose a plan
                    cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                    cookies.setCookie('email', that.email, 6 * 60 * 60 * 1000)
                    cookies.setCookie('tran_ref', res.data.tran_ref, 6 * 60 * 60 * 1000)
                    window.location = res.data.url
                  }
                } else {
                  if (Number(res.data.type) === 1) {
                  // User has already chosen a plan redirect him to setup account page
                    that.$router.push('/')
                  } else {
                  // User has already chosen a plan redirect him to setup account page
                    that.$router.push('/setup-account')
                  }
                }
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    submit () {
      this.post = true
      this.error.exist = false

      if (this.firstname === '') {
        this.error.firstname = true
        this.post = false
      } else {
        this.error.lastname = false
      }

      if (this.lastname === '') {
        this.error.lastname = true
        this.post = false
      } else {
        this.error.lastname = false
      }

      if (this.gencode === '') {
        this.error.gencode = true
        this.post = false
      } else {
        this.error.gencode = false
      }

      if (this.email == '') {
        this.error.email = true
        this.post = true
      } else {
        this.error.email = false

        if (this.str.test(this.email) === false) {
          this.error.format = true
          this.post = false
        } else {
          this.error.format = false
        }
      }

      if (this.password === '') {
        this.error.password = true
        this.post = false
      } else {
        this.error.password_length = false
        if (this.password.length < 8) {
          this.error.password_length = true
          this.post = false
        } else {
          this.error.password = false
        }
      }

      if (this.post) {
        this.$refs.loader.load()

        let data = {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          password: this.password,
          stage: sessionStorage.getItem('um') == 'trial' ? 6 : 1,
          plan: this.$route.query.pn,
          type: this.$route.query.type,
          code: this.code,
          gencode: this.gencode,
          ref: this.ref,
          country: this.country
        }

        let that = this

        AuthenticationService.useappsumocode(data).then(res => {
          if (res.data.error === true) {
            if (res.data.message === undefined || res.data.message === '') {
              that.$refs.loader.close()
              that.error.exist = true
            } else {
              that.$refs.loader.close()
              that.error.message = res.data.message
            }
          }

          if (res.data.error === false) {
            if (sessionStorage.getItem('um') == 'trial') {
              if (process.env.NODE_ENV == 'development') {
                if (res.data.source !== '' && res.data.source !== undefined) {
                  cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                  sessionStorage.removeItem('um')
                  window.location = res.data.url
                } else {
                  cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                  sessionStorage.removeItem('um')
                  window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                }
              } else {
                if (res.data.source !== '' && res.data.source !== undefined) {
                  cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                  sessionStorage.removeItem('um')
                  window.location = 'http:fexspace.com/pricing-free-trial'
                } else {
                  cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                  sessionStorage.removeItem('um')
                  window.location = res.data.url
                }
              }
            } else {
              if (res.data.url !== '') {
                if (Number(res.data.type) === 1) {
                  // Redirect user to choose a plan
                  cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                  cookies.setCookie('email', that.email, 6 * 60 * 60 * 1000)
                  that.$router.push('/')
                } else {
                  // Redirect user to choose a plan
                  cookies.setCookie('name', that.firstname + ' ' + that.lastname, 6 * 60 * 60 * 1000)
                  cookies.setCookie('email', that.email, 6 * 60 * 60 * 1000)
                  cookies.setCookie('tran_ref', res.data.tran_ref, 6 * 60 * 60 * 1000)
                  window.location = res.data.url
                }
              } else {
                if (Number(res.data.type) === 1) {
                  // User has already chosen a plan redirect him to setup account page
                  that.$router.push('/')
                } else {
                  // User has already chosen a plan redirect him to setup account page
                  that.$router.push('/setup-account')
                }
              }
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    recode (str) {
      let last_text = str[str.length - 1]
      let st = ''
      for (let i = 0; i < Number(last_text); i++) {
        st += '='
      }
      let newstr = str.substr(0, [str.length - 1])
      return newstr + st
    }
  },
  async created () {
    let { data } = await axios({ url: `https://extreme-ip-lookup.com/json`, method: 'GET' })
    // let { ldata } = await axios.get(`https://extreme-ip-lookup.com/json/`)

    if (data === undefined) {
      this.ng = false
      this.coountry = ''
    } else {
      this.country = data.country
      this.ng = data.country === 'Nigeria'
    }
  },
  mounted () {
    if (this.$route.query.code !== undefined) {
      let data = atob(this.$route.query.code)
      this.email = JSON.parse(data).email
      this.code = JSON.parse(data).code
    }

    if (this.$route.query.ref !== undefined) {
      this.ref = this.$route.query.ref
    }

    sessionStorage.setItem('um', this.$route.query.um)
  }

}
</script>
